import { initReactI18next } from 'react-i18next'

import i18n, { FormatterModule } from 'i18next'

import customi18nBackend from './backend'
import { ensureDateFnsLocale, formatDateWithActiveLocale } from './dateFnsLocale'

const customFormatter: FormatterModule = {
	type: 'formatter',
	init() {},
	add() {},
	addCached() {},
	format(value: unknown, formatKey?: string) {
		if (value instanceof Date && formatKey === 'formattedDateTime') {
			return formatDateWithActiveLocale(value)
		}

		if (value instanceof Date && formatKey === 'formattedDate') {
			return formatDateWithActiveLocale(value, false)
		}

		return String(value)
	},
}

const initI18n = async (initialLanguage: string) => {
	if (!i18n.isInitialized) {
		await i18n
			.use(customi18nBackend)
			.use(initReactI18next)
			.use(customFormatter)
			.init({
				lng: initialLanguage,
				fallbackLng: 'en',
				defaultNS: 'translation',
				ns: ['translation'],
				interpolation: {
					escapeValue: false,
				},
			})
	} else {
		await i18n.changeLanguage(initialLanguage)
	}

	return i18n
}

i18n.on('languageChanged', (lng) => {
	ensureDateFnsLocale(lng)
})

export default initI18n
